import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { Loader } from "../../../shared";
import CustomDialogFooter from "../../../shared/components/CustomDialogFooter";

function UnpairDeviceDialog({
  state,
  handleOpenDialog,
  handlePairingStatus,
  deviceDetails,
}) {
  return (
    <>
      {deviceDetails?.isLoading ? (
        <Box py="20px" minHeight="156px" my="auto">
          <Loader />
        </Box>
      ) : (
        <Stack padding="8px 16px 16px 16px" gap="16px">
          <Stack
            sx={{
              padding: "16px",
              backgroundColor: "background.default",
              borderRadius: "8px",
            }}
          >
            <Typography fontWeight={600} fontSize="16px">
              {state?.name}
            </Typography>
            <Typography fontSize="16px">{state?.store_name}</Typography>
          </Stack>

          <Typography fontSize="16px">
            Would you like to unpair this device? Once you unpair this device,
            access to this device will be removed completely.
          </Typography>
        </Stack>
      )}

      <CustomDialogFooter
        submitButton="Unpair"
        handleClose={() => handleOpenDialog(false)}
        onSubmit={handlePairingStatus}
      />
    </>
  );
}
export default UnpairDeviceDialog;
